"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _SelectFilter = _interopRequireDefault(require("../../../SelectFilter/SelectFilter"));

var _sorting = require("./sorting.constants");

/**
 * Wrapper for SelectFilter with sorting options.
 *
 * @param {Object} props
 * @param {ISortItem[]} [props.items=SORTING_ITEMS]
 * @param {string} props.value
 * @param {function(): void} props.onSort
 * @param {Object} props.otherProps
 *
 * @returns {ReactElement}
 */
var SortingSelect = function SortingSelect(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? _sorting.SORTING_ITEMS : _ref$items,
      value = _ref.value,
      onSort = _ref.onSort,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["items", "value", "onSort"]);
  var handleFilterChange = (0, _react.useCallback)(function (_ref2) {
    var sort = _ref2.sort;
    var itemValue = items.find(function (item) {
      return item.id === sort;
    });
    onSort({
      id: sort,
      value: (itemValue === null || itemValue === void 0 ? void 0 : itemValue.value) || _sorting.SORT_MOST_POPULAR.value
    });
  }, [onSort, items]);
  return /*#__PURE__*/_react["default"].createElement(_SelectFilter["default"], (0, _extends2["default"])({
    fullWidth: true,
    name: "sort",
    label: "Sort",
    value: value,
    renderItems: function renderItems() {
      return items.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
          key: item.id,
          value: item.id,
          onClick: function onClick() {
            return handleFilterChange({
              sort: item.id
            });
          }
        }, item.label);
      });
    }
  }, otherProps));
};

var _default = /*#__PURE__*/(0, _react.memo)(SortingSelect);

exports["default"] = _default;